import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=4a220920&"
import script from "../../models/customers/edit.ts?vue&type=script&lang=ts&"
export * from "../../models/customers/edit.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports